import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Change_LangugeHeader } from "../../../actions/Helper_action";
import kurdish from "../../../assets/images/kurd.png";
import eng from "../../../assets/images/eng.png";
import arabic from "../../../assets/images/iraq.png";
const Language = ({ steNavMenuClose }) => {
  const dispatch = useDispatch();
  useSelector((state) => state.HelperReducer.lang);
  const Change_Language_Kurdish = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "krd");
    window.document.body.classList.add("rtl");
    dispatch(Change_LangugeHeader(language));
    steNavMenuClose();
  };
  const Change_Language_English = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "eng");
    window.document.body.classList.remove("rtl");
    dispatch(Change_LangugeHeader(language));
    steNavMenuClose();
  };
  const Change_Language_Arabic = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "arb");
    window.document.body.classList.add("rtl");
    dispatch(Change_LangugeHeader(language));
    steNavMenuClose();
  };
  return (
    <Fragment>
      <ul className="language-dropdown onhover-show-div p-40">
        <li onClick={(e) => Change_Language_English(e, "English")}>
          <img src={eng} alt="img" className="flag-icon" /> English
        </li>
        <li
          className="fk"
          onClick={(e) => Change_Language_Kurdish(e, "Kurdish")}
        >
          <img src={kurdish} alt="img" className="flag-icon" /> کوردی
        </li>
        <li className="fk" onClick={(e) => Change_Language_Arabic(e, "Arabic")}>
          <img src={arabic} alt="img" className="flag-icon" /> عربي
        </li>
      </ul>
    </Fragment>
  );
};

export default Language;
